/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import { hasCookie, setCookie } from 'services/actions/cookies_actions';
import ModalDrlicitaImg from 'assets/images/modal_drlicita.png';
import { Container } from './styles';

interface ModalDrlicitaProps {
  show?: boolean;
  onClose?: () => void;
}

const ModalDrlicita = ({ show, onClose }: ModalDrlicitaProps) => {
  const [internalShow, setInternalShow] = useState(false);

  useEffect(() => {
    if (!hasCookie('ModalDrlicitaLatePayment')) {
      setInternalShow(true);
    }
  }, []);

  const handleClose = () => {
    setCookie('ModalDrlicitaLatePayment', true);
    setInternalShow(false);
    if (onClose) onClose();
  };

  const shouldShow = internalShow || show;

  return (
    <Modal show={shouldShow} size="lg" onHide={handleClose}>
      <Container>
        <div className="position-relative text-center bg-modal">
          <button type="button" className="close" data-dismiss="modal" onClick={handleClose}>
            <span aria-hidden="true">&times;</span>
          </button>
          <Link to="/dr_licita">
            <img className="card-img-top" src={ModalDrlicitaImg} alt="DrLicita" />
          </Link>
        </div>
      </Container>
    </Modal>
  );
};

export default ModalDrlicita;
